package ui.hardware


import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.utils.*
import tools.*
import ui.hardware.detail.*
import ui.widget.*


@ComposableNavNode
@Composable
fun HardwareListingUI() {
    with(HardwareListingScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}


@OptIn(ExperimentalFoundationApi::class)
@Composable
fun HardwareListingScope.Content(nnvl: HardwareListingScope.Wrapper) {
    Column(Modifier.fillMaxSize().padding(top = 8.dp).padding(start = 8.dp)) {
        HomeSearchUI(vm.searchFiled, label = Res.string.license_listing__search)
        Space(8.dp)
        val stateHorizontal = rememberScrollState(0)
        val itemMeasurer = headers.rememberMeasurer(16.dp)
        Box(Modifier.fillMaxSize()) {
            Box(
                Modifier.fillMaxSize()
                    .tableMeasurer(itemMeasurer)
                    .horizontalScroll(stateHorizontal)
            ) {
                LazyColumn(
                    contentPadding = PaddingValues(end = 8.dp),
                    modifier = Modifier.fillMaxHeight()
                        .width(itemMeasurer.rowWidth)
                ) {
                    stickyHeader {
                        ListingHeader(headers)
                    }
                    itemsIndexed(
                        SearchWrapper.use(
                            fields = arrayOf(
                                Io.ListingHardware.Hardware::id,
                                Io.ListingHardware.Hardware::idHex,
                                Io.ListingHardware.Hardware::name
                            ),
                            items = nnvl.state,
                            query = vm.searchFiled,
                            sort = compareByDescending<HardwareListingScope.Wrapper.Item> {
                                if (it.data.id == login.server.id) 1 else 0
                            }.thenByDescending {
                                if (it.data.id < 1000) Long.MAX_VALUE - it.data.id else it.data.id
                            }
                        )) { _, item ->
                        ListingDivider()
                        ListingItem(
                            item = item,
                            specs = headers,
                            background = if (login.server.id == item.data.id) MaterialTheme.colorScheme.tertiaryContainer
                            else MaterialTheme.colorScheme.surfaceContainer
                        ) {
                            nav.findRoot().navTo_HardwareDetailUI(HardwareDetailArgs(item.data.id))
                        }
                    }

                    ListingFooter()
                }
            }
            HorizontalScrollbar(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(bottom = 8.dp)
                    .fillMaxWidth(),
                adapter = rememberScrollbarAdapter(stateHorizontal)
            )
            if (nnvl.canAdd) {
                FloatingActionButton(
                    onClick = {
                        nav.findRoot().navTo_HardwareDetailUI(HardwareDetailArgs(-1L))
                    },
                    modifier = Modifier.align(Alignment.BottomEnd)
                        .padding(24.dp)
                ) {
                    Icon(Svg.Plus, null)
                }
            }
        }
    }
}

